import React, { useCallback } from 'react';

import { EmptyGrid } from '@components/LayoutGrid';

import InformationBox from '@components/InformationBox';
import { LeftGrid } from '@components/LayoutGrid';
import Text from '@components/Text';
import Heading from '@components/Heading';
import Button from '@components/Button';
import Link from '@components/Link';
import { get } from 'lodash';
import { useAvivaSelector } from '@redux/hook';

export interface UnsuccessfulPaymentProps {
  tryAgain: () => void;
}

function UnsuccessfulPayment({ tryAgain }: UnsuccessfulPaymentProps) {

  const backToAviva = useCallback(() => {
    const website = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
    window.open(website, '_self');
  }, [])

  return <>
    <LeftGrid>
      <InformationBox hasClose variant="error">
        <Text>Payment is unsuccessful</Text>
      </InformationBox>
      <Heading>Oops...</Heading>
      <Heading margin="0 0 30px" variant="label">There seems to be a problem with your payment, and your purchase is incomplete.</Heading>
      <Heading margin="0 0 30px" variant="label">You may wish to check your credit card details or select another payment option.</Heading>
      <Text margin="0 0 40px">
        Alternatively, you can contact our Customer Service Centre at <Link text="+65 6827 9966" />, Mondays to Fridays between 8.45am and 5.30pm for assistance.
      </Text>
      <Button margin="0 0 20px" label="Try again" onClick={tryAgain} />
      <Button margin="0 0 40px" label="Back to website" variant='secondary' onClick={backToAviva} />
    </LeftGrid>
    <EmptyGrid></EmptyGrid>
  </>;
};

export default UnsuccessfulPayment;
